import React from "react";
import { CustomersList } from "./customers-list";

export function CustomersTable({ rows, onViewDetails }) {
  return <CustomersList rows={rows} onViewDetails={onViewDetails} />;
}
